import {
    getNameOrId,
    ProductIdentifiers,
    ProductNames,
} from '@/libs/product'
import { reviewFact, reviewText, statusFromRuntime } from '../../runtime/review-contribution-helpers'

const createGeneralProductInformationReviewContribution = ({ context, step }) => {
    const product = context.product || (context.request && context.request.product) || {}
    const productName = getNameOrId(
        Array.isArray(product.names) ? product.names : [],
        ProductNames.OUR_PRODUCT_NAME,
    )
    const productIdentifier = getNameOrId(
        Array.isArray(product.identifiers) ? product.identifiers : [],
        ProductIdentifiers.PRODUCT_ID,
    )

    return {
        status: statusFromRuntime(step),
        summary: reviewText(
            'Page(ReceivedRequest):Component(WorkflowReview):product-information-summary',
            'Product information provided',
        ),
        facts: [
            reviewFact(
                'product-name',
                reviewText('Component(Label):product-name', 'Product'),
                productName || '—',
            ),
            reviewFact(
                'product-id',
                reviewText('Component(Label):product-id', 'Product ID'),
                productIdentifier || '—',
            ),
        ],
        checks: [],
    }
}

export { createGeneralProductInformationReviewContribution }
export default createGeneralProductInformationReviewContribution
